import { Playground, PlaygroundState } from './Playground';
import Position from './Position';

export default class View {
	private playgroundElement: HTMLElement = document.getElementById('playground');
	private minesCountElement: HTMLElement = document.getElementById('rest-count');
	private timerElement: HTMLElement = document.getElementById('timer');
	private smileElement = <HTMLImageElement>document.getElementById('smile');

	private positionsPreviousState: Position[][] = null;

	private flagImage = 'img/flag.svg';
	private mineImage = 'img/mine.svg';
	private deadImage = 'img/dead.svg';

	constructor() {
		new Image().src = this.flagImage;
		new Image().src = this.mineImage;
		new Image().src = this.deadImage;
	}

	createPlayground(playground: Playground) {
		this.playgroundElement.innerHTML = '';
		for (let row = 0; row < playground.height; row++) {
			const tr = document.createElement('tr');
			for (let cell = 0; cell < playground.width; cell++) {
				const td = document.createElement('td');
				td.setAttribute('id', `${row}-${cell}`);
				td.setAttribute('data-playground', `true`);
				td.appendChild(document.createElement('div'));
				tr.appendChild(td);
			}
			this.playgroundElement.appendChild(tr);
		}
	}

	private copyPlayground(playground: Playground) {
		const copy = JSON.stringify(playground.positions);
		this.positionsPreviousState = JSON.parse(copy);
	}

	renderPlayground(playground: Playground) {
		if (!this.positionsPreviousState) this.copyPlayground(playground);

		let markedCount = 0;
		for (let row = 0; row < playground.height; row++) {
			for (let cell = 0; cell < playground.width; cell++) {
				const position = playground.positions[row][cell];
				const positionPreviousState = this.positionsPreviousState[row][cell];
				const positionOuterElement = document.getElementById(`${row}-${cell}`);
				if (position.marked) markedCount++;

				const positionInnerElement = document.createElement('div');
				if (position.uncover) {
					if (!positionOuterElement.classList.contains('uncover')) {
						positionOuterElement.classList.add('uncover');
					}
					if (position.minesAround) positionInnerElement.textContent = position.minesAround.toString();
				}

				if ((position.mine && position.uncover) || (position.mine && playground.state !== PlaygroundState.Active)) {
					positionInnerElement.innerHTML = '';
					const mine = document.createElement('img');
					mine.src = this.mineImage;
					positionInnerElement.appendChild(mine);
				}

				if (position.marked) {
					positionInnerElement.innerHTML = '';
					const flag = document.createElement('img');
					flag.src = this.flagImage;
					positionInnerElement.appendChild(flag);
					positionInnerElement.style.color = 'green';
				}

				if (position.markedWrong) {
					positionOuterElement.classList.add('mistake');
				}

				if (position.exploded) {
					positionInnerElement.innerHTML = '';
					positionOuterElement.classList.add('mistake');
					const mine = document.createElement('img');
					mine.src = this.mineImage;
					positionInnerElement.appendChild(mine);
				}

				if (!position.mine && position.minesAround && position.uncover) {
					positionOuterElement.classList.add('count' + position.minesAround);
				}

				// Update only changes
				if (JSON.stringify(position) !== JSON.stringify(positionPreviousState) || playground.state !== PlaygroundState.Active) {
					positionOuterElement.innerHTML = '';
					positionOuterElement.appendChild(positionInnerElement);
				}

				if (playground.state === PlaygroundState.Win) {
					positionOuterElement.classList.add('uncover');
				} else if (playground.state === PlaygroundState.Loss) {
					this.smileElement.src = this.deadImage;
				}
			}
		}
		this.minesCountElement.textContent = (playground.minesCount - markedCount).toString();
		this.copyPlayground(playground);
	}

	renderTime(startTime: number) {
		const miliseconds = Date.now() - startTime;
		let seconds = Math.round(miliseconds / 1000);
		const minutes = Math.floor(seconds / 60);
		seconds -= minutes * 60;
		let minutesString = minutes.toString();
		if (minutesString.length === 1) minutesString = '0' + minutesString;
		let secondsString = seconds.toString();
		if (secondsString.length === 1) secondsString = '0' + secondsString;
		this.timerElement.textContent = minutesString + ':' + secondsString;
	}
}
